export const PREFERENCES_FORM_STEP = 50_000;

export const PREFERENCES_FORM_MAX_DEFAULT = 4_500_000;

export const PREFERENCES_FORM_MAX_MODIFIER = 1.5;
export const PREFERENCES_FORM_STEP = 50_000;

export const PREFERENCES_FORM_MAX_DEFAULT = 4_500_000;

export const PREFERENCES_FORM_MAX_MODIFIER = 1.5;
